// src/hooks/useEstadoInscripcion.js
import { useMemo } from 'react';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export function useEstadoInscripcion(taller, serverTime) {
  const tallerActivo = taller?.estado === 'activo' && taller?.inscripcionesEstado === 'abiertas';
  const tieneVentanaInscripcion = !!(taller?.inscripcionInicio || taller?.inscripcionFin);

  const estadoInscripcion = useMemo(() => {
    if (!tallerActivo) {
      return {
        tipo: 'desactivado',
        mensaje: 'Las inscripciones están cerradas para este taller',
        mostrarFormulario: false
      };
    }

    if (!tieneVentanaInscripcion) {
      return {
        tipo: 'abierto_sin_ventana',
        mensaje: null,
        mostrarFormulario: true
      };
    }

    // ✅ Usar hora del servidor; si aún no llega, no mostrar formulario todavía
    if (!serverTime) {
      return {
        tipo: 'cargando',
        mensaje: null,
        mostrarFormulario: false
      };
    }

    const ahora = dayjs(serverTime);
    console.log('⏰ Evaluando estado de inscripción con hora del servidor:', ahora.format('YYYY-MM-DD HH:mm:ss'));
    const inicio = taller.inscripcionInicio ? dayjs(taller.inscripcionInicio) : null;
    const fin = taller.inscripcionFin ? dayjs(taller.inscripcionFin) : null;

    if (inicio && !fin) {
      if (ahora.isBefore(inicio)) {
        return {
          tipo: 'proximo',
          mensaje: `Las inscripciones abrirán el ${inicio.format('DD/MM/YYYY')}`,
          fechaInicio: inicio.format('DD/MM/YYYY'),
          mostrarFormulario: false
        };
      }
      return {
        tipo: 'abierto_desde',
        mensaje: null,
        mostrarFormulario: true
      };
    }

    if (!inicio && fin) {
      if (ahora.isAfter(fin)) {
        return {
          tipo: 'cerrado',
          mensaje: `Las inscripciones cerraron el ${fin.format('DD/MM/YYYY')}`,
          fechaFin: fin.format('DD/MM/YYYY'),
          mostrarFormulario: false
        };
      }
      return {
        tipo: 'abierto_hasta',
        mensaje: null,
        mostrarFormulario: true
      };
    }

    if (inicio && fin) {
      if (ahora.isBefore(inicio)) {
        return {
          tipo: 'proximo',
          mensaje: `Las inscripciones abrirán del ${inicio.format('DD/MM/YYYY')} al ${fin.format('DD/MM/YYYY')}`,
          fechaInicio: inicio.format('DD/MM/YYYY'),
          fechaFin: fin.format('DD/MM/YYYY'),
          mostrarFormulario: false
        };
      }

      if (ahora.isAfter(fin)) {
        return {
          tipo: 'cerrado',
          mensaje: `Las inscripciones cerraron el ${fin.format('DD/MM/YYYY')}`,
          fechaInicio: inicio.format('DD/MM/YYYY'),
          fechaFin: fin.format('DD/MM/YYYY'),
          mostrarFormulario: false
        };
      }

      return {
        tipo: 'abierto_ventana',
        mensaje: null,
        fechaInicio: inicio.format('DD/MM/YYYY'),
        fechaFin: fin.format('DD/MM/YYYY'),
        mostrarFormulario: true
      };
    }

    return {
      tipo: 'desconocido',
      mensaje: 'Estado de inscripción no disponible',
      mostrarFormulario: false
    };
  }, [taller?.inscripcionInicio, taller?.inscripcionFin, taller?.estado, taller?.inscripcionesEstado, tallerActivo, tieneVentanaInscripcion, serverTime]);

  return estadoInscripcion;
}
